import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { log } from 'utils';

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartMarketAffect(props) {

  const DEFAULT_OPTION = {
    grid: { top: 10, right: 15, bottom: 40, left: 40 },
    color: ['#0FC786', '#F5465C'],
    tooltip: {
      // show: false,
      trigger: 'item',
      // formatter: '{a} <br/>{b}: {c}',
      formatter: function (value, index) {
        // console.log(value);
        return `${value.name} <br/> ${props.t(
          'algo.pttt.txt-contrib-index-per'
        )}: ${value.value} <br/>${props.t(
          'algo.pttt.txt-contrib-index-point'
        )}: ${value.data.point}`;
      },
    },
    legend: {
      show: false,
    },
    xAxis: {
      type: 'category',
      data: [],
      splitLine: {
        show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
        alignWithLabel: false,
        length: 3,
      },
      axisLabel: {
        color: (props.theme === 'light' ? '#000000' : '#ECECEC'),
        fontSize: 8,
        borderColor: (props.theme === 'light' ? '#000000' : '#ECECEC'),
        rotate: 45,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'left',
      alignTicks: true,
      splitNumber: 4,
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'solid',
          color: '#2E2D3D',
          // dashOffset: 10,
          // opacity: 0.3,
        },
      },
      axisLabel: {
        color: (props.theme === 'light' ? '#000000' : '#ECECEC'),
        fontSize: 8,
        showMinLabel: true,
        showMaxLabel: true,
        // formatter: function (value, index) {
        //   return value + ' tỷ';
        // },
      },
    },
    series: [
      {
        type: 'bar',
        name: 'Top ảnh hưởng',
        data: [],
      },
    ],
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { topAnhHuong } = props;

  const preTopAnhHuong = usePrevious(topAnhHuong);

  useEffect(() => {
    if (topAnhHuong && !_.isEqual(topAnhHuong, preTopAnhHuong)) {
      _mapDataToState(topAnhHuong);
    }
  }, [topAnhHuong]);

  function _mapDataToState(res) {
    const newOption = _.cloneDeep(option);

    let objData = [],
      index = 0;

    res.upVal.forEach((element, i) => {
      objData.push({
        name: res.name[index],
        value: element,
        point: res.upPoint[i],
        itemStyle: {
          color: '#13BA7F',
        },
      });
      index++;
    });

    res.downVal.forEach((element, i) => {
      objData.push({
        name: res.name[index],
        value: element,
        point: res.downPoint[i],
        itemStyle: {
          color: '#F5465C',
        },
      });
      index++;
    });

    newOption.xAxis.data = res.name;
    newOption.series[0].data = objData;

    newOption.xAxis.axisLabel.color = props.theme === 'light' ? '#000000' : '#ECECEC';
    newOption.yAxis.axisLabel.color = props.theme === 'light' ? '#000000' : '#ECECEC';

    setOption(newOption);
  }

  return (
    <ReactECharts
      option={option}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartMarketAffect);
